import { render, staticRenderFns } from "./OnboardingEditor.vue?vue&type=template&id=37189268&"
import script from "./OnboardingEditor.vue?vue&type=script&lang=js&"
export * from "./OnboardingEditor.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports